import React, { useRef, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { usePuzzle } from './PuzzleContext'
import { cn } from '@/lib/utils'

interface PuzzleNodeProps {
  nodeId: string
}

export const PuzzleNode: React.FC<PuzzleNodeProps> = ({ nodeId }) => {
  const { topology, values, setValue, setFocusedNodeId } = usePuzzle()
  const node = topology.nodes.find(n => n.id === nodeId)
  
  if (!node) return null

  const value = values[nodeId] !== undefined ? values[nodeId] : ''
  const isLocked = node.isLocked || false

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (isLocked) return
    const val = e.target.value
    setValue(nodeId, val)
  }

  return (
    <div 
      className="absolute transform -translate-x-1/2 -translate-y-1/2"
      style={{ left: `${node.x}%`, top: `${node.y}%` }}
    >
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        className={cn(
          "w-10 h-10 md:w-12 md:h-12 rounded-full shadow-md flex items-center justify-center border-2 transition-colors",
          isLocked 
            ? "bg-slate-100 border-slate-300 text-slate-500" 
            : "bg-white border-primary/50 focus-within:border-primary focus-within:ring-2 focus-within:ring-primary/20"
        )}
      >
        <input
          value={value}
          onChange={handleChange}
          onFocus={() => setFocusedNodeId(nodeId)}
          onBlur={() => setFocusedNodeId(null)}
          disabled={isLocked}
          className={cn(
            "w-full h-full text-center bg-transparent border-none outline-none font-bold text-lg md:text-xl",
            isLocked ? "cursor-not-allowed" : "cursor-text"
          )}
          placeholder={node.placeholder}
        />
      </motion.div>
    </div>
  )
}
